import {
  START_LOADING_LOGIN_FAILED_LOGS,
  LOGIN_FAILED_LOGS_LOAD_SUCCESS,
  LOGIN_FAILED_LOGS_LOAD_FAILED,
} from '../actions/types';

const initialState = {
  loadingLoginFailedLogs: false,
  loginFailedLogs: []
};

const loginFailedLogReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_LOADING_LOGIN_FAILED_LOGS:
      return {
        ...state,
        loadingLoginFailedLogs: true
      };
    case LOGIN_FAILED_LOGS_LOAD_SUCCESS:
      return {
        ...state,
        loadingLoginFailedLogs: false,
        loginFailedLogs: Array.isArray(payload.data) ? payload.data : []
      };
    case LOGIN_FAILED_LOGS_LOAD_FAILED:
      return {
        ...state,
        loadingLoginFailedLogs: false
      };
    default:
      return state;
  }
};

export default loginFailedLogReducer;
